module.exports = __webpack_public_path__ + "html/wave-header_ee57a68fb3e8e35ed1745eb8987e5390.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave-header.html
// module id = eXN9
// module chunks = 154